import { useMemo } from "react";

import { FilterOptionsCount, FilterSourceData } from "../typing";
import { getBanksByProgram } from "../utils";

function count(
  list: FilterSourceData,
  type: "total" | "progress",
  result: FilterOptionsCount
): FilterOptionsCount {
  if (!result["programs"]) {
    result["programs"] = {} as FilterOptionsCount["programs"];
  }

  if (!result["banks"]) {
    result["banks"] = {} as FilterOptionsCount["banks"];
  }

  const programs = result["programs"];
  const banks = result["banks"];

  for (let index = 0; index < list.length; index++) {
    // programs
    const programCode = list[index].program;

    if (programs[programCode]) {
      programs[programCode][type]++;
    } else {
      programs[programCode] =
        type === "total"
          ? {
              total: 1,
              progress: 0,
            }
          : {
              total: 0,
              progress: 1,
            };
    }

    // banks
    const bankList = getBanksByProgram(programCode);
    bankList.forEach((bank) => {
      if (banks[bank]) {
        banks[bank][type]++;
      } else {
        banks[bank] =
          type === "total"
            ? {
                total: 1,
                progress: 0,
              }
            : {
                total: 0,
                progress: 1,
              };
      }
    });
  }

  return result;
}

export const useFilterOptionsCount = (
  list: FilterSourceData,
  data: FilterSourceData
): FilterOptionsCount => {
  return useMemo(() => {
    const result = {} as FilterOptionsCount;
    count(list, "total", result);
    count(data, "progress", result);

    return result;
  }, [list, data]);
};
